import * as flexsearch from "flexsearch";

import { IPresentation, IWorkspaceResourcePresentation, IWorkspaceResourcePresentationTemplate, IWorkspaceResourceWithDocument, WorkspaceResourceType } from "common/interfaces";
import { IPresentationsSearchDocument } from "common/interfaces/search/ISearchDocument";

import { BaseWorkspaceResourcesController, BaseWorkspaceResourcesControllerState } from "./BaseWorkspaceResourcesController";

export type IPresentationsPanePresentation = Pick<IPresentation, "id" | "name" | "createdAt" | "modifiedAt" | "userId" | "modifiedBy" | "slideRefs" | "firstSlideModifiedAt" | "softDeletedAt" | "finishedEditingAt" | "metadata">;
export type BasePresentationsPaneControllerState<TResource extends (IWorkspaceResourcePresentation | IWorkspaceResourcePresentationTemplate) = IWorkspaceResourcePresentation> = BaseWorkspaceResourcesControllerState<IPresentationsPanePresentation, TResource>;

export class BasePresentationsPaneController<TResource extends (IWorkspaceResourcePresentation | IWorkspaceResourcePresentationTemplate) = IWorkspaceResourcePresentation, TState extends BasePresentationsPaneControllerState<TResource> = BasePresentationsPaneControllerState<TResource>>
    extends BaseWorkspaceResourcesController<IPresentationsPanePresentation, TResource, IPresentationsSearchDocument<TResource>, TState> {
    protected get _resourceTypes(): WorkspaceResourceType[] {
        throw new Error("Not implemented");
    }

    protected get _documentFields(): (keyof IPresentationsPanePresentation)[] {
        return ["id", "name", "createdAt", "modifiedAt", "userId", "modifiedBy", "slideRefs", "firstSlideModifiedAt", "softDeletedAt", "finishedEditingAt", "metadata"];
    }

    protected get _batchSize() {
        return 30;
    }

    protected _searchDocumentToResourceWithDocument(searchDocument: IPresentationsSearchDocument<TResource>): IWorkspaceResourceWithDocument<IPresentationsPanePresentation, TResource> {
        return {
            resource: searchDocument.resource,
            permission: searchDocument.permission,
            document: searchDocument.presentation,
            composedAt: searchDocument.composedAt,
        };
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        throw new Error("Not implemented");
    }

    public async initialize(props: Omit<Parameters<BaseWorkspaceResourcesController<IPresentationsPanePresentation, TResource, IPresentationsSearchDocument<TResource>, TState>["initialize"]>[0], "resourceTypes">) {
        await super.initialize({ ...props, resourceTypes: this._resourceTypes } as Parameters<BaseWorkspaceResourcesController<IPresentationsPanePresentation, TResource, IPresentationsSearchDocument<TResource>, TState>["initialize"]>[0]);
    }
}
